import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw } from "lucide-react";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/10 p-4">
      <div className="w-full max-w-md rounded-lg border border-destructive/20 bg-card p-6 shadow-lg">
        <div className="mb-4 flex items-start gap-4">
          <div className="shrink-0">
            <AlertCircle className="size-6 text-destructive" />
          </div>
          <div className="flex-1">
            <h2 className="mb-2 text-xl font-bold text-destructive">
              Something went wrong
            </h2>
            <p className="mb-4 text-sm text-muted-foreground">
              {error.message || "An unexpected error occurred"}
            </p>
            {process.env.NODE_ENV === 'development' && (
              <details className="mt-2 rounded bg-muted/50 p-4 text-xs text-muted-foreground">
                <summary className="cursor-pointer font-medium">
                  Error details (dev only)
                </summary>
                <pre className="mt-2 whitespace-pre-wrap">
                  {error.stack}
                </pre>
              </details>
            )}
          </div>
        </div>
        <div className="flex gap-4">
          <Button
            onClick={resetErrorBoundary}
            className="flex-1"
            variant="default"
          >
            <RefreshCw className="mr-2 size-4" />
            Try Again
          </Button>
          <Button
            onClick={() => window.location.href = '/'}
            variant="outline"
            className="flex-1"
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
}
